
import { defineComponent } from "vue"
import { useToast } from "vue-toastification"
import ConvInput from "./ConvInput.vue"
import ConvButton from "./ConvButton.vue"
import { Convert } from "../scripts/Convert"

const toast = useToast()

export default defineComponent({
	name: "Converter",
	components: {
		ConvInput,
		ConvButton
	},
	data() {
		return {
			encoded: "",
			decoded: "",
			pnach: ""
		}
	},
	methods: {
		decode() {
			this.decoded = Convert.decode(this.encoded)
			this.convertToPnach()
			toast.success("複合化しました。")
		},
		encode() {
			this.encoded = Convert.encode(this.decoded)
			toast.success("暗号化しました。")
		},
		convertToPnach() {
			this.pnach = Convert.toPnach(this.decoded)
			toast.success("pnachコードに変換しました。")
		},
		deconvertFromPnach() {
			this.decoded = Convert.fromPnach(this.pnach)
			toast.success("pnachコードから復元しました。")
		},
		copyPnach() {
			navigator.clipboard.writeText(this.pnach)
			toast.success("pnachコードをコピーしました。")
		}
	}
})
